export const services = [
  {
    id: 1,
    title: "Limpieza de Casas",
    description: "Limpieza completa y detallada para tu hogar. Cubrimos cada habitación, baño, cocina y área común con atención al detalle y productos de alta calidad.",
    image: "https://public.readdy.ai/ai/img_res/3dbaffd1578459cf8263c44e936547c6.jpg",
    features: ["Todas las habitaciones", "Cocina y baños a fondo", "Aspirado y fregado", "Limpieza de ventanas"],
    icon: "ri-home-heart-line",
    color: "from-teal-50 to-emerald-50",
    iconColor: "text-teal-600",
  },
  {
    id: 2,
    title: "Limpieza de Apartamentos",
    description: "Servicio especializado para apartamentos y condominios. Limpieza eficiente adaptada a espacios modernos con horarios flexibles para tu comodidad.",
    image: "https://readdy.ai/api/search-image?query=professional%20apartment%20cleaning%20service%20modern%20bright%20condo%20clean%20kitchen%20living%20area%20organized%20fresh%20spotless%20natural%20light%20minimal%20contemporary&width=400&height=400&seq=102&orientation=squarish",
    features: ["Cocina completa", "Baños sanitizados", "Sala y dormitorios", "Balcón y áreas comunes"],
    icon: "ri-building-line",
    color: "from-sky-50 to-blue-50",
    iconColor: "text-sky-600",
  },
  {
    id: 3,
    title: "Limpieza de Oficinas",
    description: "Mantenemos tu espacio de trabajo impecable y productivo. Disponible en horarios nocturnos o fines de semana para no interrumpir tu jornada laboral.",
    image: "https://readdy.ai/api/search-image?query=professional%20office%20cleaning%20service%20modern%20bright%20workspace%20clean%20desks%20organized%20commercial%20space%20spotless%20floors%20natural%20light%20contemporary%20business&width=400&height=400&seq=103&orientation=squarish",
    features: ["Escritorios y áreas de trabajo", "Baños y cocina", "Pisos y alfombras", "Servicio nocturno disponible"],
    icon: "ri-briefcase-line",
    color: "from-indigo-50 to-violet-50",
    iconColor: "text-indigo-600",
  },
  {
    id: 4,
    title: "Move In / Move Out",
    description: "Limpieza profunda especializada para mudanzas. Dejamos el espacio impecable antes de entrar o al salir, garantizando la devolución de tu depósito.",
    image: "https://readdy.ai/api/search-image?query=move%20in%20move%20out%20deep%20cleaning%20service%20empty%20apartment%20spotless%20clean%20bright%20white%20walls%20floors%20shining%20professional%20thorough%20cleaning%20fresh%20start&width=400&height=400&seq=104&orientation=squarish",
    features: ["Limpieza profunda total", "Dentro de armarios y cajones", "Electrodomésticos incluidos", "Garantía de depósito"],
    icon: "ri-door-open-line",
    color: "from-emerald-50 to-green-50",
    iconColor: "text-emerald-600",
  },
];

export const frequencies = [
  { id: 1, label: "Semanal", icon: "ri-calendar-check-line", desc: "Cada semana" },
  { id: 2, label: "Quincenal", icon: "ri-calendar-2-line", desc: "Cada 2 semanas" },
  { id: 3, label: "Mensual", icon: "ri-calendar-line", desc: "Una vez al mes" },
  { id: 4, label: "Servicio Único", icon: "ri-star-line", desc: "Sin compromiso" },
];

export const howItWorks = [
  {
    step: "01",
    title: "Cotización Personalizada",
    description: "Contáctanos y cuéntanos sobre tu espacio. Te enviamos una cotización gratuita adaptada exactamente a tus necesidades.",
    icon: "ri-file-list-3-line",
    color: "bg-teal-500",
  },
  {
    step: "02",
    title: "Confirmamos tu Cita",
    description: "Elegimos juntos el día y horario que mejor te convenga. Nuestro equipo se adapta a tu agenda.",
    icon: "ri-calendar-check-line",
    color: "bg-emerald-500",
  },
  {
    step: "03",
    title: "Servicio Profesional",
    description: "Nuestro equipo certificado llega puntual y transforma tu espacio. Tú solo relájate y disfruta el resultado.",
    icon: "ri-shield-check-line",
    color: "bg-green-500",
  },
];

export const advantages = [
  {
    id: 1,
    title: "Personal Confiable",
    description: "Todo nuestro equipo pasa por verificación de antecedentes y entrenamiento profesional antes de entrar a tu hogar.",
    icon: "ri-shield-user-line",
    color: "text-teal-600",
    bg: "bg-teal-50",
  },
  {
    id: 2,
    title: "Productos de Calidad",
    description: "Usamos productos de limpieza profesionales, seguros para tu familia, mascotas y el medio ambiente.",
    icon: "ri-leaf-line",
    color: "text-emerald-600",
    bg: "bg-emerald-50",
  },
  {
    id: 3,
    title: "Flexibilidad de Horarios",
    description: "Nos adaptamos a tu agenda. Mañanas, tardes, noches o fines de semana. Tú decides cuándo.",
    icon: "ri-time-line",
    color: "text-green-600",
    bg: "bg-green-50",
  },
  {
    id: 4,
    title: "Atención Personalizada",
    description: "Cada cliente es único. Personalizamos el servicio según tus preferencias y necesidades específicas.",
    icon: "ri-heart-line",
    color: "text-teal-600",
    bg: "bg-teal-50",
  },
  {
    id: 5,
    title: "Garantía de Satisfacción",
    description: "Si no quedas 100% satisfecho, regresamos sin costo adicional. Tu satisfacción es nuestra prioridad.",
    icon: "ri-medal-line",
    color: "text-emerald-600",
    bg: "bg-emerald-50",
  },
  {
    id: 6,
    title: "Equipo Asegurado",
    description: "Contamos con seguro de responsabilidad civil. Tu hogar y pertenencias están completamente protegidos.",
    icon: "ri-secure-payment-line",
    color: "text-green-600",
    bg: "bg-green-50",
  },
];

export const stats = [
  { value: "500+", label: "Clientes Satisfechos" },
  { value: "5+", label: "Años de Experiencia" },
  { value: "100%", label: "Garantía de Satisfacción" },
  { value: "25+", label: "Profesionales Certificados" },
];

export const testimonials = [
  {
    id: 1,
    name: "María González",
    location: "Miami, FL",
    rating: 5,
    title: "¡Increíble servicio!",
    text: "Contraté el servicio de move out y quedé absolutamente impresionada. Cada rincón del apartamento brillaba. El equipo fue puntual, profesional y muy detallista. Me devolvieron el depósito completo.",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20latina%20woman%20smiling%20friendly%20professional%20headshot%20clean%20white%20background%20warm%20light%2035%20years%20old%20natural%20look&width=80&height=80&seq=110&orientation=squarish",
  },
  {
    id: 2,
    name: "Carlos Rodríguez",
    location: "Orlando, FL",
    rating: 5,
    title: "Servicio quincenal perfecto",
    text: "Llevo 8 meses con el plan quincenal y no podría estar más satisfecho. Siempre llegan a tiempo, usan productos de calidad y mi casa siempre queda perfecta. Totalmente recomendado.",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20latino%20man%20smiling%20professional%20headshot%20clean%20white%20background%20warm%20light%2040%20years%20old%20natural%20look&width=80&height=80&seq=111&orientation=squarish",
  },
  {
    id: 3,
    name: "Ana Martínez",
    location: "Tampa, FL",
    rating: 5,
    title: "Move in impecable",
    text: "Usé el servicio de move in antes de mudarme a mi nuevo apartamento y fue la mejor decisión. El lugar quedó reluciente, como nuevo. Excelente inversión para empezar bien en tu nuevo hogar.",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20woman%20smiling%20friendly%20professional%20headshot%20clean%20white%20background%20warm%20light%2028%20years%20old%20latina%20natural&width=80&height=80&seq=112&orientation=squarish",
  },
  {
    id: 4,
    name: "Roberto Sánchez",
    location: "Jacksonville, FL",
    rating: 5,
    title: "Oficina siempre impecable",
    text: "Contratamos el servicio semanal para nuestra oficina y el resultado es excelente. Vienen en horario nocturno, no interrumpen el trabajo y siempre encontramos todo perfecto al llegar.",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20man%20smiling%20professional%20headshot%20clean%20white%20background%20warm%20light%2045%20years%20old%20hispanic%20natural%20look&width=80&height=80&seq=113&orientation=squarish",
  },
  {
    id: 5,
    name: "Laura Pérez",
    location: "Fort Lauderdale, FL",
    rating: 5,
    title: "Mi casa nunca estuvo tan limpia",
    text: "Soy muy exigente con la limpieza y este es el único servicio que ha cumplido mis estándares. Usan productos ecológicos que no dañan a mis mascotas y el resultado es espectacular.",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20woman%20smiling%20professional%20headshot%20clean%20white%20background%20warm%20light%2032%20years%20old%20natural%20look&width=80&height=80&seq=114&orientation=squarish",
  },
  {
    id: 6,
    name: "Diego Flores",
    location: "Miami Beach, FL",
    rating: 5,
    title: "Atención personalizada increíble",
    text: "Lo que más me sorprendió fue la atención personalizada. Se adaptaron a mis horarios y preferencias desde el primer día. El equipo es amable, profesional y muy detallista.",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20young%20man%20smiling%20professional%20headshot%20clean%20white%20background%20warm%20light%2030%20years%20old%20latin%20natural&width=80&height=80&seq=115&orientation=squarish",
  },
];
